const invalidBasePrefix = /^(?:undefined|null)(?=\/)/i;

export function resolveApiUrl(input: string): string {
  const value = input.trim();
  if (/^https?:\/\//i.test(value)) {
    return value;
  }

  const cleaned = value.replace(invalidBasePrefix, "");
  const path = cleaned.startsWith("/") ? cleaned : `/${cleaned}`;
  if (typeof window === "undefined" || !window.location.origin || window.location.origin === "null") {
    return path;
  }

  return new URL(path, `${window.location.origin}/`).toString();
}
